var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2778 0H9.72222C4.35279 0 0 4.47715 0 10V25C0 30.5228 4.35279 35 9.72222 35H25.2778C30.6472 35 35 30.5228 35 25V10C35 4.47715 30.6472 0 25.2778 0Z",
    fill: "#D3FF9A",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5361 14.2503L16.6862 19.1011L14.4639 16.8787C14.3842 16.7991 14.2897 16.7359 14.1857 16.6928C14.0816 16.6497 13.9701 16.6275 13.8575 16.6275C13.7449 16.6275 13.6334 16.6497 13.5294 16.6928C13.4253 16.7359 13.3308 16.7991 13.2512 16.8787C13.1715 16.9583 13.1084 17.0528 13.0653 17.1569C13.0222 17.2609 13 17.3724 13 17.485C13 17.5976 13.0222 17.7091 13.0653 17.8132C13.1084 17.9172 13.1715 18.0118 13.2512 18.0914L16.0799 20.9201C16.1595 20.9997 16.2541 21.0629 16.3581 21.1059C16.4621 21.149 16.5736 21.1712 16.6862 21.1712C16.7988 21.1712 16.9103 21.149 17.0144 21.1059C17.1184 21.0629 17.213 20.9997 17.2926 20.9201L22.7488 15.4639C22.9097 15.303 23 15.0849 23 14.8575C23 14.6301 22.9097 14.412 22.7488 14.2512C22.588 14.0903 22.3699 14 22.1425 14C21.9151 14 21.697 14.0894 21.5361 14.2503Z",
    fill: "#D3FF9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.242c6164f889b94ece28136ff6a084d8.svg";
export { ForwardRef as ReactComponent };